import {
  Pagination,
  PaginationAriaLabels
} from '../models/paginator.interfaces';

export const paginationPagesMocks: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const paginationAriaLabelsMocks: PaginationAriaLabels = {
  title: 'Pagination Navigation',
  previous: 'Go to previous page',
  current: 'Current page, page',
  next: 'Go to next page'
};

export const firstPage = 1;
export const lastPage = 10;

export const paginationMocks: Pagination = {
  previous: '← Previous',
  next: 'Next →',
  indexes: paginationPagesMocks,
  pageSize: 10,
  first: firstPage,
  last: lastPage,
  ariaLabels: paginationAriaLabelsMocks,
  activePage: 1
};

export const paginationErrorMocks: Pagination = {
  previous: '← Previous',
  next: 'Next →',
  indexes: [],
  pageSize: 10,
  first: 0,
  last: 0,
  ariaLabels: paginationAriaLabelsMocks,
  activePage: 1
};
